import React from 'react';
import DescriptionArea from '../../Components/DescriptionArea';
import ComponentMenu from '../../Components/Menu'

export default function FirstPage() {
  return (
    <>
      <ComponentMenu />
      <DescriptionArea />
    </>
  );
}
